import joinUrl from "../../utils/join-url";
import requestUtility from "../../helpers/request-utility";

const getPackageCancellationCoupon = (apiUrl) => () => {
  const url = joinUrl(
    apiUrl,
    `/checkoutservice/pb/users/me/package-cancellation-coupon/`
  );
  return requestUtility.get(url);
};

export default getPackageCancellationCoupon;
